function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import React from 'react';
import { connect } from 'react-redux';
import Button from "../../Common/FooterButton";
import { useCefEventTracker } from "../../Hooks/useCefEventTracker";
import { CefEvent, CefEventName, Platform } from "../../../../EventTracker";
import { determineTheReasonWhyQ6IsInvalid } from "../../../../EventTracker/utilities";
import { Keys, Routes } from "../../Common/Constants";
import useCefNavigation from "../../Hooks/useCefNavigation";
import { getApplication, getValidKeys } from "../../../../store/Selectors";
export var UnconnectedOverallGradeQuestionFooterButton = function UnconnectedOverallGradeQuestionFooterButton(_ref) {
  var isMostRecentOverallGradeValid = _ref.isMostRecentOverallGradeValid,
    mostRecentOverallGrade = _ref.mostRecentOverallGrade,
    setFormValidated = _ref.setFormValidated;
  var navigate = useCefNavigation();
  var _useCefEventTracker = useCefEventTracker(),
    trackEvent = _useCefEventTracker.trackEvent;
  var onClick = function onClick() {
    if (isMostRecentOverallGradeValid) {
      navigate(Routes.Eligibility.EnglishTestsQuestion);
    } else {
      var theReasonWhyQ6IsInvalid = determineTheReasonWhyQ6IsInvalid(mostRecentOverallGrade);
      trackEvent(CefEvent(CefEventName.FailedToNavigateToNextStep, Platform.Mobile, {
        incomplete_fields: Keys.Application.mostRecentOverallGrade,
        reason: theReasonWhyQ6IsInvalid
      }));
      setFormValidated(true);
    }
  };
  return /*#__PURE__*/React.createElement(Button, {
    form: "question-six-form",
    label: "Next",
    onClick: onClick
  });
};
var mapStateToProps = function mapStateToProps(state) {
  var _ref2;
  var application = getApplication(state);
  var validKeys = getValidKeys(state);
  return _ref2 = {}, _defineProperty(_ref2, Keys.Application.mostRecentOverallGrade, application.mostRecentOverallGrade), _defineProperty(_ref2, "isMostRecentOverallGradeValid", validKeys.includes(Keys.Application.mostRecentOverallGrade)), _ref2;
};
var connector = connect(mapStateToProps);
export var FooterButton = connector(UnconnectedOverallGradeQuestionFooterButton);